import * as React from "react";

// style, design
import CancelLeaseContractForm from "../../components/Forms/ManagementContract/CancelForm/FlowForm";

export default function CancelManagementContractForm() {
  return <CancelLeaseContractForm />;
}
